<template>
  <div class="tiptap-editor">
    <div
      class="tiptap-editor-toolbar sticky-top"
      v-if="editor && editor.isEditable"
    >
      <div
        class="tiptap-editor-btn"
        v-tooltip="'text styles'"
        @click="showTextStyles = !showTextStyles"
      >
        <v-icon small>mdi-format-text</v-icon>
      </div>

      <span v-if="showTextStyles" class="d-flex">
      <div
        class="tiptap-editor-btn"
        v-tooltip="'Bold'"
        @click="editor.chain().focus().toggleBold().run()"
        :class="{ 'is-active': editor && editor.isActive('bold') }"
      >
        <small class="english">B</small>
      </div>

      <div
        @click="editor.chain().focus().toggleItalic().run()"
        :disabled="!editor.can().chain().focus().toggleItalic().run()"
        :class="{ 'is-active': editor.isActive('italic') }"
        class="tiptap-editor-btn"
        v-tooltip="'Italic'"
      >
        <small class="english">I</small>
      </div>

      <div
        class="tiptap-editor-btn"
        v-tooltip="'Underline'"
        @click="editor.chain().focus().toggleUnderline().run()"
        :class="{ 'is-active': editor && editor.isActive('underline') }"
      >
        <small class="english"><u>U</u></small>
      </div>
      </span>

      <div
        class="tiptap-editor-btn"
        v-tooltip="'Dhivehi text'"
        @click="editor.chain().focus().toggleBdi().run()"
        :class="{ 'is-active': editor && editor.isActive('bdi') }"
      >
        <small class="dhivehi">ދި</small>
      </div>

      <div style="width: 3px;"></div>

      <div
        @click="editor.chain().focus().setParagraph().run()"
        :class="{ 'is-active': editor.isActive('paragraph') }"
        class="tiptap-editor-btn"
        v-tooltip="'Paragraph'"
      >
        <small class="english">P</small>
      </div>

      <div
        @click="showHeadings = !showHeadings"
        class="tiptap-editor-btn"
        v-tooltip="'Headings'"
      >
        <!-- <small class="english">H</small> -->
        <v-icon small>{{ showHeadings ? 'mdi-format-header-decrease' : 'mdi-format-header-increase' }}</v-icon>
      </div>

      <span v-if="showHeadings" class="d-flex">
      <div
        @click="editor.chain().focus().toggleHeading({ level: 1 }).run()"
        :class="{ 'is-active': editor.isActive('heading', { level: 1 }) }"
        class="tiptap-editor-btn"
        v-tooltip="'Heading 1'"
      >
        <small class="english">H1</small>
      </div>

      <div
        @click="editor.chain().focus().toggleHeading({ level: 2 }).run()"
        :class="{ 'is-active': editor.isActive('heading', { level: 2 }) }"
        class="tiptap-editor-btn"
        v-tooltip="'Heading 2'"
      >
        <small class="english">H2</small>
      </div>

      <div
        @click="editor.chain().focus().toggleHeading({ level: 3 }).run()"
        :class="{ 'is-active': editor.isActive('heading', { level: 3 }) }"
        class="tiptap-editor-btn"
        v-tooltip="'Heading 3'"
      >
        <small class="english">H3</small>
      </div>

      <div
        @click="editor.chain().focus().toggleHeading({ level: 4 }).run()"
        :class="{ 'is-active': editor.isActive('heading', { level: 4 }) }"
        class="tiptap-editor-btn"
        v-tooltip="'Heading 4'"
      >
        <small class="english">H4</small>
      </div>

      <div
        @click="editor.chain().focus().toggleHeading({ level: 5 }).run()"
        :class="{ 'is-active': editor.isActive('heading', { level: 5 }) }"
        class="tiptap-editor-btn"
        v-tooltip="'Heading 5'"
      >
        <small class="english">H5</small>
      </div>

      <div
        @click="editor.chain().focus().toggleHeading({ level: 6 }).run()"
        :class="{ 'is-active': editor.isActive('heading', { level: 6 }) }"
        class="tiptap-editor-btn"
        v-tooltip="'Heading 6'"
      >
        <small class="english">H6</small>
      </div>
      </span>


      <div style="width: 3px;"></div>

      <div
        class="tiptap-editor-btn"
        v-tooltip="'text alignment'"
        @click="showTextAlign = !showTextAlign" 
      >
        <v-icon small>mdi-align-horizontal-left</v-icon>
      </div>

      <span v-if="showTextAlign" class="d-flex">
      <div
        class="tiptap-editor-btn"
        v-tooltip="'align text to left'"
        @click="editor.chain().focus().setTextAlign('left').run()" 
        :class="{ 'is-active': editor.isActive({ textAlign: 'left' }) }"
      >
        <v-icon small>mdi-format-align-left</v-icon>
      </div>

      <div
        class="tiptap-editor-btn"
        v-tooltip="'align text to center'"
        @click="editor.chain().focus().setTextAlign('center').run()" 
        :class="{ 'is-active': editor.isActive({ textAlign: 'center' }) }"
      >
        <v-icon small>mdi-format-align-center</v-icon>
      </div>

      <div
        class="tiptap-editor-btn"
        v-tooltip="'align text to right'"
        @click="editor.chain().focus().setTextAlign('right').run()" 
        :class="{ 'is-active': editor.isActive({ textAlign: 'right' }) }"
      >
        <v-icon small>mdi-format-align-right</v-icon>
      </div>

      <div
        class="tiptap-editor-btn"
        v-tooltip="'justify text'"
        @click="editor.chain().focus().setTextAlign('justify').run()" 
        :class="{ 'is-active': editor.isActive({ textAlign: 'justify' }) }"
      >
        <v-icon small>mdi-format-align-justify</v-icon>
      </div>
      </span>

      <div style="width: 3px;"></div>

      <div
        class="tiptap-editor-btn"
        v-tooltip="'Indentation'"
        @click="showTextIndent = !showTextIndent"
      >
        <v-icon small class="flip">mdi-format-horizontal-align-left</v-icon>
      </div>

      <span v-if="showTextIndent" class="d-flex">
      <div
        class="tiptap-editor-btn"
        v-tooltip="'Indent Paragraph'"
        @click="editor.chain().focus().indent().run()"
      >
        <v-icon small class="flip">mdi-format-indent-increase</v-icon>
      </div>

      <div
        class="tiptap-editor-btn"
        v-tooltip="'Outdent Paragraph'"
        @click="editor.chain().focus().outdent().run()"
      >
        <v-icon small class="flip">mdi-format-indent-decrease</v-icon>
      </div>
      </span>

      <div style="width: 3px;"></div>

      <!-- <div
        class="tiptap-editor-btn"
        v-tooltip="'Page Break'"
        @click="focusLog"
      >
        <v-icon small class="flip">mdi-format-page-break</v-icon>
      </div> -->
        <!-- @click="editor.commands.setPageBreak()" -->

      <div
        class="tiptap-editor-btn"
        v-tooltip="'Horizontal Line'"
        @click="editor.commands.setHorizontalRule()"
      >
        <v-icon small class="flip">mdi-minus</v-icon>
      </div>

      <div style="width: 3px;"></div>

      <div
        class="tiptap-editor-btn"
        v-tooltip="'New table'"
        v-if="editor && !editor.isActive('table')"
        @click="
          editor
            .chain()
            .focus()
            .insertTable({ rows: 1, cols: 2, withHeaderRow: false })
            .run()
        "
      >
        <v-icon small>mdi-table-plus</v-icon>
      </div>

      <div
        class="tiptap-editor-btn"
        v-tooltip="'Table borders'"
        v-if="
          editor &&
          editor.isActive('table') &&
          !editor.isActive('table', { class: 'border' })
        "
        @click="editor.chain().focus().addClassName('border').run()"
      >
        <v-icon small>mdi-table-border</v-icon>
      </div>

      <div
        class="tiptap-editor-btn is-active"
        v-tooltip="'Table borders'"
        v-if="editor && editor.isActive('table', { class: 'border' })"
        @click="editor.chain().focus().removeClassName('border').run()"
      >
        <v-icon small>mdi-table-border</v-icon>
      </div>

      <div
        class="tiptap-editor-btn"
        v-tooltip="'Add row above'"
        v-if="editor && editor.isActive('table')"
        @click="editor.chain().focus().addRowBefore().run()"
      >
        <v-icon small>mdi-table-row-plus-before</v-icon>
      </div>

      <div
        class="tiptap-editor-btn"
        v-tooltip="'Add row below'"
        v-if="editor && editor.isActive('table')"
        @click="editor.chain().focus().addRowAfter().run()"
      >
        <v-icon small>mdi-table-row-plus-after</v-icon>
      </div>

      <div
        class="tiptap-editor-btn"
        v-tooltip="'Delete row'"
        v-if="editor && editor.isActive('table')"
        @click="editor.chain().focus().deleteRow().run()"
      >
        <v-icon small>mdi-table-row-remove</v-icon>
      </div>

      <div
        class="tiptap-editor-btn"
        v-tooltip="'Add column to left'"
        v-if="editor && editor.isActive('table')"
        @click="editor.chain().focus().addColumnAfter().run()"
      >
        <v-icon small>mdi-table-column-plus-before</v-icon>
      </div>

      <div
        class="tiptap-editor-btn"
        v-tooltip="'Add column to right'"
        v-if="editor && editor.isActive('table')"
        @click="editor.chain().focus().addColumnBefore().run()"
      >
        <v-icon small>mdi-table-column-plus-after</v-icon>
      </div>

      <div
        class="tiptap-editor-btn"
        v-tooltip="'Delete column'"
        v-if="editor && editor.isActive('table')"
        @click="editor.chain().focus().deleteColumn().run()"
      >
        <v-icon small>mdi-table-column-remove</v-icon>
      </div>

      <div
        class="tiptap-editor-btn"
        v-tooltip="'Delete table'"
        v-if="editor && editor.isActive('table')"
        @click="editor.chain().focus().deleteTable().run()"
      >
        <v-icon small>mdi-table-remove</v-icon>
      </div>

      <div style="width: 3px;"></div>

      <div
        class="tiptap-editor-btn"
        v-tooltip="'list settings'"
        v-if="editor"
        @click="showList = !showList"
      >
        <v-icon small>mdi-format-list-text</v-icon>
      </div>

      <span v-if="showList" class="d-flex">
      <div
        class="tiptap-editor-btn"
        v-tooltip="'bullet list'"
        v-if="editor"
        @click="editor.chain().focus().toggleBulletList().run()"
        :class="{ 'is-active': editor.isActive('bulletList') }"
      >
        <v-icon small>mdi-format-list-bulleted</v-icon>
      </div>

      <div
        class="tiptap-editor-btn"
        v-tooltip="'ordered list'"
        v-if="editor"
        @click="editor.chain().focus().toggleOrderedList().run()"
      >
        <v-icon small>mdi-format-list-numbered</v-icon>
      </div>

      <div
        class="tiptap-editor-btn"
        v-tooltip="'split list'"
        v-if="editor"
        @click="editor.chain().focus().splitListItem('listItem').run()"
        :disabled="!editor.can().splitListItem('listItem')"
      >
        <v-icon small>mdi-list-status</v-icon>
      </div>

      <div
        class="tiptap-editor-btn"
        v-tooltip="'Sink List'"
        v-if="editor"
        @click="editor.chain().focus().sinkListItem('listItem').run()"
        :disabled="!editor.can().sinkListItem('listItem')"
      >
        <v-icon small>mdi-format-list-checks</v-icon>
      </div>

      <div
        class="tiptap-editor-btn"
        v-tooltip="'Lift List | clear list'"
        v-if="editor"
        @click="editor.chain().focus().liftListItem('listItem').run()"
        :disabled="!editor.can().liftListItem('listItem')"
      >
        <v-icon small>mdi-playlist-remove</v-icon>
      </div>
      </span>

      <div style="width: 3px;"></div>

      <!-- toggle button for database table fields -->
      <div 
        class="tiptap-editor-btn"
        :class="{ 'is-active': showFieldsSearch }"
        v-tooltip="'search fields'"
        v-if="editor && template_id && dataProviders && dataProviders.length > 0"
        @click="() => showFieldsSearch = !showFieldsSearch"
      >
        <v-icon small>mdi-form-textbox</v-icon>
      </div>

      <!-- toggle button for custom fields -->
      <div 
        class="tiptap-editor-btn"
        :class="{ 'is-active': showCustomFields }"
        v-tooltip="'custom fields'"
        v-if="editor && custom_fields && custom_fields.length > 0"
        @click="() => showCustomFields = !showCustomFields"
      >
        <v-icon small>mdi-format-textbox</v-icon>
      </div>

      <!-- toggle button for code blocks -->
      <div 
        class="tiptap-editor-btn"
        :class="{ 'is-active': showCodeBlocks }"
        v-tooltip="'text blocks'"
        v-if="editor && template_id"
        @click="() => showCodeBlocks = !showCodeBlocks"
      >
        <v-icon small>mdi-toy-brick-plus-outline</v-icon>
      </div>

      <!-- toggle button for signature -->
      <div 
        class="tiptap-editor-btn"
        :class="{ 'is-active': showSignatureBlock }"
        v-tooltip="'signature'"
        v-if="editor && template_id"
        @click="() => showSignatureBlock = !showSignatureBlock"
      >
        <v-icon small>mdi-draw-pen</v-icon>
      </div>

      <div v-if="$can('all_permissions')" style="width: 20px;"></div>

      <!-- all permissions option -->
      <div
        v-if="!viewHtml && $can('all_permissions')"
        class="tiptap-editor-btn"
        v-tooltip="'Edit HTML'"
        @click="(htmlContent = editor.getHTML()), (viewHtml = true)"
      >
        <v-icon small>mdi-xml</v-icon>
      </div>

      <div
        v-if="viewHtml && $can('all_permissions')"
        class="tiptap-editor-btn is-active"
        v-tooltip="'Set HTML'"
        @click="setHtml()"
      >
        <v-icon small>mdi-xml</v-icon>
      </div>
    </div>

    <!-- show custom field options -->
    <div
      class="tiptap-editor-toolbar sticky-top"
      v-if="editor && editor.isEditable && showCustomFields"
    >
      <div v-if="custom_fields && custom_fields.length > 0">
        <v-chip outlined small v-for="(field, index) in custom_fields" :key="index" @click="addCustomField(field)">
          {{field.label}}
        </v-chip>
      </div>
    </div>

    <!-- show signature options -->
    <div
      class="tiptap-editor-toolbar sticky-top"
      v-if="editor && editor.isEditable && showSignatureBlock"
    >
      <div v-if="signatureOptions && signatureOptions.length > 0">
        <v-chip outlined small v-for="(item, index) in signatureOptions" :key="index+'sign'" @click="addSignature(item, 'sign')">
          {{item.label}} Sign
        </v-chip>
        <v-chip outlined small v-for="(item, index) in signatureOptions" :key="index+'name'" @click="addSignature(item, 'name')">
          {{item.label}} Name
        </v-chip>
        <v-chip outlined small v-for="(item, index) in signatureOptions" :key="index+'position'" @click="addSignature(item, 'position')">
          {{item.label}} Position
        </v-chip>
      </div>
    </div>

    <!-- show code block options -->
    <div
      class="tiptap-editor-toolbar sticky-top"
      v-if="editor && editor.isEditable && showCodeBlocks"
    >
      <div v-if="codeBlocks && codeBlocks.length > 0">
        <v-chip outlined small v-for="(block, index) in codeBlocks" :key="block.id" @click="addCodeBlock(index)">
          {{block.label}}
        </v-chip>
      </div>
    </div>

    <!-- show database table options -->
    <div 
      class="tiptap-editor-toolbar sticky-top"
      v-if="editor && editor.isEditable && showFieldsSearch"
    >
      <v-autocomplete
        dense
        outlined
        v-model="selectedDataProvider"
        label="Data Options"
        clearable
        :items="dataProviders"
        item-text="label"
        item-value="model_name"
        class="mt-2"
        @change="getOptions"
      ></v-autocomplete>

      <div v-if="fieldOptions.length > 0">
        <div>
          <v-icon v-tooltip="'clear'" color="error" @click="clearOptions">mdi-close</v-icon>
        </div>
        <v-chip
          v-for="option in fieldOptions"
          :key="option"
          outlined
          small
          @click="() => addField(option)"
        >
          {{option}}
        </v-chip>
      </div>
    </div>

    <div
      id="tiptap-html"
      class="english"
      style="font-size: 0.9em"
      v-if="viewHtml"
      contenteditable="true"
    >
      {{ htmlContent }}
    </div>

    <editor-content
      v-if="!viewHtml"
      class="tiptap-editor-content"
      :class="{'ltr-mode': ltr}"
      :editor="editor"
    />
  </div>
</template>

<script>
import { Editor, EditorContent } from "@tiptap/vue-2"
import StarterKit from "@tiptap/starter-kit"
import Bdi from './extensions/bdi'
import TextAlign from '@tiptap/extension-text-align'
import Underline from "@tiptap/extension-underline"
import TableRow from "@tiptap/extension-table-row"
import TableCell from "@tiptap/extension-table-cell"
import TableHeader from "@tiptap/extension-table-header"
import Indent from "./extensions/indent"
import Table from "./extensions/customTable"
import TextStyle from '@tiptap/extension-text-style'
import Image from '@tiptap/extension-image'
import Styles from './extensions/styles'


// import PageBreak from './extensions/pageBreak';

export default {
  components: {
    EditorContent,
  },
  props: ['value', 'template_id', 'custom_fields', 'disabled', 'ltr'],
  data() {
    return {
      showHeadings: false,
      showTextStyles: false,
      showTextAlign: false,
      showTextIndent: false,
      showList: false,
      editor: null,
      viewHtml: false,
      htmlContent: null,
      showFieldsSearch: false,
      showCustomFields: false,
      showCodeBlocks: false,
      showSignatureBlock: false,
      dataProviders: [],
      fieldOptions: [],
      codeBlocks: [],
      signatureOptions: [],
      selectedDataProvider: null,
    };
  },
  methods: {
    addSignature(val, attribute) {
      if (attribute === 'name') {
        this.editor.commands.insertContent(`{{ $${val.field_name}['DhiStaffName'] }}`)
        return
      }

      if (attribute === 'position') {
        this.editor.commands.insertContent(`{{ $${val.field_name}['DhiPosition'] }}`)
        return
      }

      this.editor.commands.setImage({src: `{{ $${val.field_name}['signature'] }}`})
      // this.editor.commands.setImage({src: `/user-files/get-signature/7872e6343721faf2a4cd3dd31bf7a667`})
    },
    addCodeBlock(index) {
      this.editor.commands.insertContent(this.codeBlocks[index].value)
    },
    getCodeBlocks() {
      // this.$axios.get(`/api/code_blocks`).then((resp) => {
      //   this.codeBlocks = resp.data
      // })
    },
    getDocumentTemplate() {
      if (!this.template_id) return
      this.$axios.get(`/api/document_templates/${this.template_id}`).then((resp) => {
        this.dataProviders = resp.data.data_providers
        this.signatureOptions = resp.data.signers
      })
    },
    clearOptions() {
      this.selectedDataProvider = null
      this.fieldOptions = []
    },
    addField(val) {
      this.editor.commands.insertContent(`{{ $${this.selectedDataProvider}['${val}'] }}`)
    },
    addCustomField(val) {
      this.editor.commands.insertContent(`{{ $${val.field_name} }}`)
    },
    getOptions() {
      if (!this.selectedDataProvider) return
      this.$axios.get(`/api/document-templates/getTableFields/${this.template_id}/${this.selectedDataProvider}`)
        .then((resp) => {
          this.fieldOptions = resp.data
        })
    },
    setHtml() {
      var tag = document.querySelector("#tiptap-html")
      console.log(tag.getHTML().replaceAll('&lt;/', '</').replaceAll('&lt;', '<').replaceAll('&gt;', '>'))

      this.editor.commands.setContent(tag.innerHTML.toString(), false)
      this.viewHtml = false
    },
  },
  watch: {
    value(value) {
      if (this.editor.getHTML() === value) return
      this.editor.commands.setContent(value, false)

      //  if (!this.editor.focused) {
      //   this.editor.setContent(val, false);
      // }
    },
    disabled(val){
      this.editor.setOptions({editable: !val})
    }
  },
  mounted() {
    this.getDocumentTemplate()
    this.getCodeBlocks()

    this.editor = new Editor({
      extensions: [
        StarterKit,
        Bdi,
        TextAlign.configure({
          types: ['heading', 'paragraph'],
        }),
        Styles.configure({
          types: ['paragraph'],
          styles: ['width' , 'background-color', 'margin-right']
        }),
        Underline,
        Indent,
        Table, //.configure({resizable: true}),
        TableRow,
        TableCell,
        TableHeader,
        TextStyle,
        Image.configure({
          inline: true,
          allowBase64: true,
        }),
        // PageBreak,
      ],
      content: this.value,
      editable: !this.disabled,
      onUpdate: () => this.$emit("input", this.editor.getHTML()),
    })
  },
  beforeDestroy() {
    this.editor?.destroy()
    Object.assign(this.$data, this.$options.data())
  },
}
</script>

<style scoped>
.tiptap-editor {
  border: 1px solid lightgrey;
  color: black !important;
  /* border-radius: 4px; */
}
.tiptap-editor-toolbar.sticky-top {
  position: sticky;
  top: 0;
  z-index: 2;
}
.tiptap-editor-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  background-color: lightgrey;
  padding: 5px;
}
.tiptap-editor-btn {
  border: 1px solid grey;
  width: 20px;
  height: 25px;
  text-align: center;
  cursor: pointer;
}
.tiptap-editor-btn:hover {
  background-color: #bbb;
}

.tiptap-editor-content {
  padding: 5px;
  background-color: #fafafa;
  min-height: 40px;
  /* text-align: justify; */
  /* direction: rtl; */
}
.ProseMirror:focus-visible {
  outline: 0px solid transparent !important;
}
.tiptap-editor-content bdi {
  background-color: lightgrey;
  font-family: faruma, Roboto, sans-serif !important;
}
.tiptap-editor-content ul, ol, li {
  direction: rtl !important;
}
.flip {
  transform: rotateY(180deg);
}
.tiptap-editor-btn.is-active {
  border-color: rgb(0, 110, 255) !important;
  box-shadow: inset 0 0 4px rgb(0, 110, 255);
}
.tiptap-editor-btn.is-active > * {
  color: rgb(0, 110, 255);
}
/* .is-active > * {
  background-color: lightgreen;
} */

.tiptap img {
  width: 150px;
  height: 150px;
}

span.d-flex .tiptap-editor-btn {
  background-color: #c0e2ed;
}


/* page break */
.tiptap pagebreak {
  border-bottom: black dashed 2px;
}

.tiptap div[data-page-break="true"].ProseMirror {
    opacity: 0.3;
    border-width: 2px 0;
    border-style: dashed;
    border-color: currentColor;
}

.tiptap div[data-page-break="true"].ProseMirror-selectednode {
    opacity: 1;
}

.tiptap div[data-page-break="true"].ProseMirror::before {
    content: "\F06D7";
    display: block;
    font: normal normal normal 24px/1 "Material Design Icons";
    text-align: center;
}
</style>

<style lang="scss">
@for $i from 1 through 8 {
  [data-indent="#{$i}"] {
    $val: $i * 3rem;
    padding-right: $val;
  }

  .ProseMirror {
    font-family: Roboto, sans-serif !important;;
    // font-family: faruma;
    font-size: 16px;
    background-color: white;
    table {
      border-collapse: collapse;
      table-layout: auto;
      width: 100%;
      margin: 5px 0;
      overflow: hidden;

      td,
      th {
        min-width: 1em;
        border: 1px dashed #ced4da;
        padding: 3px 5px;
        vertical-align: top;
        box-sizing: border-box;
        position: relative;

        // > * {
        //   margin-bottom: 0;
        // }
      }

      // td:first-of-type {
      //   width: 25%;
      // }

      th {
        font-weight: bold;
        text-align: center;
        background-color: #f1f3f5;
      }

      .selectedCell:after {
        z-index: 2;
        position: absolute;
        content: "";
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: rgba(200, 200, 255, 0.4);
        pointer-events: none;
      }

      .column-resize-handle {
        position: absolute;
        right: -2px;
        top: 0;
        bottom: -2px;
        width: 4px;
        background-color: #adf;
        pointer-events: none;
      }

      p:last-of-type {
        margin: 0;
      }
    }
  }

  .resize-cursor {
    cursor: ew-resize;
    cursor: col-resize;
  }

  .tableWrapper {
    padding: 10px 0;
    overflow-x: auto;
  }
  .ProseMirror * {
    white-space: pre-wrap;
    word-wrap: break-word;
  }

  .ltr-mode .ProseMirror {
    direction: ltr !important;
    text-align: left !important;
  }

  .ProseMirror {
    direction: rtl;
    ol {
      list-style-type: none;
      counter-reset: item;
      margin: 0;
      padding: 0;
    }

    ol > li {
      display: table;
      counter-increment: item;
      margin-bottom: 0.6em;
    }

    ol > li:before {
      content: counters(item, ".") ". ";
      display: table-cell;
      padding-right: 0.6em;
    }

    li ol > li {
      margin: 0;
    }

    li ol > li:before {
      content: counters(item, ".") " ";
    }
  }
}
</style>